import { Text } from '@/components/text';
import { Button } from '@/components/ui/button';
import { HoverCard } from '@/components/ui/hover-card';
import { View } from '@/components/ui/tw-wrappers';
import { RESUME_CONFIGS } from '@/constants/scenarios';
import { Colors } from '@/constants/theme';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Badge } from './ui/badge';
import { Tooltip } from './ui/tooltip';

interface AlsoThereCardProps {
  onSchedulePress: () => void;
  className?: string;
}

export const AlsoThereCard: React.FC<AlsoThereCardProps> = ({ onSchedulePress, className }) => {
  const { t } = useTranslation();
  const config = RESUME_CONFIGS['alsoThere'];

  return (
    <HoverCard backgroundColor='white' className={`w-full ${className || ''}`}>
      <View className='flex-col md:flex-row md:items-center gap-6'>
        <View className='flex-row md:items-center gap-4 flex-1'>
          <MaterialCommunityIcons name='check-decagram' size={36} color={Colors.light.primary} />
          <View className='flex-col flex-1'>
            <Text type='subtitle'>
              {t('home.compare.cta.scheduleAlsoThere.title', 'Simplify your payments with AlsoThere')}
            </Text>
            <Text style={styles.description}>
              {t(
                'home.compare.cta.scheduleAlsoThere.description',
                'A specialized payment solution for international invoicing.'
              )}
            </Text>
          </View>
        </View>
        <View className=' gap-2'>
          <Tooltip
            content={t('scenarios.resultsBadge.risk')}
          >
            <Badge
              label={t(`scenarios.types.alsoThere.resume.risk`)}
              color={config.badge.risk.color}
              iconName={config.badge.risk.iconName}
              style={styles.badge}
            />
          </Tooltip>
          <Tooltip
            content={t('scenarios.resultsBadge.competitiveness')}
          >
            <Badge
              label={t(`scenarios.types.alsoThere.resume.competitiveness`)}
              color={config.badge.competitiveness.color}
              iconName={config.badge.competitiveness.iconName}
              style={styles.badge}
            />
          </Tooltip>
        </View>
        <Button
          label={t('home.compare.cta.scheduleAlsoThere.button', 'Schedule a meeting')}
          onPress={onSchedulePress}
          variant='primary'
          style={styles.scheduleButton}
          className='w-full md:w-auto'
          outlinedUntilHover={true}
        />
      </View>
    </HoverCard>
  );
};

const styles = StyleSheet.create({
  description: {
    fontSize: 14,
    color: Colors.light.secondaryText,
  },
  badge: {
    alignSelf: 'center',

  },
  scheduleButton: {
    height: 48,
    minWidth: 160,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
